export default __webpack_public_path__ + "static/yahooFinance-308-cbc1f626ab431f16d127869eb8835c41.png";